import EditOrderPageComponent from "./components/EditOrderPageComponent";
import axios from "axios";

const fetchOrder = async (orderId) => {
    const { data } = await axios.get(`/api/orders/${orderId}`);
    return data;
}

const updateOrderApiRequest = async (orderId, title, name, surname, telephone, mobile, email, via, cap, citta, provincia, piva, codicefiscale, image) => {
    const { data } = await axios.put(`/api/orders/${orderId}`, { title, name, surname, telephone, mobile, email, via, cap, citta, provincia, piva, codicefiscale, image});
    return data;
}

const getOrder = async(orderId) => {
    //const { data } = await axios.get("/api/orders/user/" + id);
    console.log("[getOrder] api recupero dati ordine con id=",orderId)
    const { data } = await axios.get(`/api/orders/details/${orderId}`);
    return data
}

const markAsDelivered = async (id) => {
    const { data } = await axios.put("/api/orders/delivered/" + id);
    if (data) {
        return data;
    }
}

const AdminEditOrderPage = () => {
  return <EditOrderPageComponent getOrder={getOrder} markAsDelivered={markAsDelivered} />
};

export default AdminEditOrderPage;
